import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Python multiprocessing is fucking sweet",
  "description": "",
  "published": "2010-01-18T00:00:00.000Z",
  "redirect_from": ["/blog/python-multiprocessing-is-fucking-sweet/swizec/1150"],
  "categories": "Application programming interface, food for thought, life, Multi-core, Multiprocessing, Parallel computing, Process, Programming, Thread, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Cray-1-p1010221.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/300px-Cray-1-p1010221.jpg",
              "alt": "CRAY-1 (no longer used, of course) displayed i...",
              "title": "CRAY-1 (no longer used, of course) displayed i..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Cray-1-p1010221.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`You know how it is said every programmer needs to learn how to do `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Parallel_computing",
        "title": "Parallel computing"
      }}>{`parallelisation`}</a>{` and funky stuff on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Multi-core",
        "title": "Multi-core"
      }}>{`multi-core`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Multiprocessing",
        "title": "Multiprocessing"
      }}>{`multi-processor`}</a>{` beast of machines? And how such machines aren't even really beasts these days, they're our run of the mill desktop and portable computers.`}</p>
    <p>{`This is the world we live in.`}</p>
    <p>{`It's getting worse by the hour!`}</p>
    <p>{`Very soon the first thing a young programmer will hear out of a lecturer's mouth will be `}<em parentName="p">{`"`}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Thread_safety",
          "title": "Thread safety"
        }}>{`Thread-Safe`}</a>{`"`}</em>{`.`}</p>
    <p>{`But there's something we can do about that even today. First of all, we can kiss threading good bye. Sure it's sweet and yes it sort of works. But ew! It's like trying to make a marine corps do their job with everyone's finger in someone else's arse.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      